export const prefix = "Can you take the below as input. \n";
export const suffix = "Create a html for your answer. \n";
